import { Parser } from 'expr-eval';
import LoggerUtil from './LoggerUtil';
import { APPS_COMPONENT_ID } from './enums';

class FilterUtil {
    apps;

    parser = new Parser();

    sectionType = '';

    section={};

    constructor() {
        this.parser.functions.OR = this.getUnion.bind(this);
        this.parser.functions.AND = this.getIntersection.bind(this);
        this.parser.functions.NOT = this.getInverse.bind(this);
    }

    getFilteredArray(filter) {
        if (Array.isArray(filter)) {
            return filter;
        }

        return this.apps.filter(app => (app[this.sectionType].slice().includes(filter)));
    }

    getUnion(...args) {
        const unionList = [];
        Array.from(args).forEach((filter) => {
            unionList.push(...this.getFilteredArray(filter));
        });
        return [
            ...new Set([
                ...unionList,
            ]),
        ];
    }

    getIntersection(...args) {
        let intersectionList = this.apps;
        Array.from(args).forEach((filter) => {
            const filteredApps = this.getFilteredArray(filter);
            intersectionList = intersectionList.filter(app => (filteredApps.includes(app)));
        });
        return intersectionList;
    }

    getDifference(filterA, filterB) {
        const filteredArrayA = this.getFilteredArray(filterA);
        const filteredArrayB = this.getFilteredArray(filterB);
        return filteredArrayA.filter(app => !(filteredArrayB.includes(app)));
    }

    getInverse(...args) {
        const filterOutList = this.getUnion(...args);
        const completeAppsList = this.apps;
        return this.getDifference(completeAppsList, filterOutList);
    }

    /**
     * getFilteredApps function
     * Returns a list of apps satisfying the query
     * 'union', 'intersection', 'difference' of filters is supported
     * ex query: AND(OR("desktop","mobile"),"mobile")
     * @return {object[]}
     */

    getFilteredApps = (apps = [], section, sectionType, contentFilter = '') => {
        this.sectionType = sectionType;
        this.apps = apps;
        let filteredApps = apps;

        if (!contentFilter.includes('AND') && !contentFilter.includes('OR') && !contentFilter.includes('NOT')) {
            return apps.filter(app => (app[sectionType].slice().includes(section.id)));
        }

        try {
            filteredApps = this.parser.evaluate(contentFilter);
        } catch (error) {
            LoggerUtil.warn(`${APPS_COMPONENT_ID}: filterUtil: filtering failed for: ${contentFilter}`);
        }
        return filteredApps;
    }
}

export default new FilterUtil();
